<template>
	<div class="home-view h-full p-2">
		<div v-if="fileContent" class="pb-16">
			<div class="max-w-5xl mx-auto border-solid border-2 border-gray-600 rounded-md">
				<details v-for="(data, fileName) in parsedFileContent" :key="fileName" open="true">
					<summary>{{ fileName }}</summary>
					<Hunk
						v-for="(hunk, hunkIdx) in data"
						:key="hunkIdx"
						:hunk="hunk"
						:file-name="fileName"
						:hunk-idx="hunkIdx"
						:shift-clicking="shiftClicking"
						class="mb-2 border-t-2 border-gray-400"
					></Hunk>
				</details>
			</div>
			<div class="max-w-3xl mx-auto mt-4 text-center">
				<label class="mr-2">Display Name:</label>
				<input type="text" placeholder="Display Name" v-model="username" />
			</div>
			<div class="comments max-w-3xl mx-auto mt-4 mb-4">
				<NewComment :selected-snippet="selectedSnippet"></NewComment>
				<Comment v-for="comment in comments" :key="comment.id" :comment="comment" class="w-full"></Comment>
			</div>
			<button class="fixed bottom-0 right-0 mr-4 mb-4" @click="onClickExport">Export</button>
		</div>
		<UploadView v-else class="h-full" />
	</div>
</template>

<script>
import { saveAs } from 'file-saver';
import { mapState, mapGetters } from 'vuex';
import Comment from '@/components/Comment.vue';
import NewComment from '@/components/NewComment.vue';
import Hunk from '@/components/Hunk.vue';
import UploadView from '@/components/UploadView.vue';

export default {
	name: 'Home',
	components: {
		Comment,
		NewComment,
		Hunk,
		UploadView,
	},
	data() {
		return {
			shiftClicking: false,
		};
	},
	computed: {
		...mapState(['fileContent', 'parsedFileContent', 'comments']),
		...mapGetters(['selectedSnippet']),
		username: {
			get() {
				return this.$store.state.username;
			},
			set(value) {
				this.$store.commit('setUsername', value);
			},
		},
	},
	mounted() {
		window.addEventListener('keydown', this.onKeydown);
		window.addEventListener('keyup', this.onKeyup);
	},
	destoyed() {
		window.removeEventListener('keydown', this.onKeydown);
		window.removeEventListener('keyup', this.onKeyup);
	},
	methods: {
		onKeydown(e) {
			this.shiftClicking = e.key == 'Shift';
		},
		onKeyup() {
			this.shiftClicking = false;
		},
		onClickExport() {
			const to_export = JSON.stringify({
				fileContent: this.fileContent,
				comments: this.comments,
			});
			const fileName = `code-review-${new Date().toISOString()}.json`;

			// Create a blob of the data
			const fileToSave = new Blob([to_export], {
				type: 'application/json',
				name: fileName,
			});

			// Save the file
			saveAs(fileToSave, fileName);
		},
	},
};
</script>
